<template>
	<div :class="[$style.subbar]">
		<ul
			:class="$style.breadcrumbs"
			class="mr-0 mr-sm-4"
		>
			<li
				v-for="(item, i) in breads"
				:key="i"
				:class="$style.breadcrumb"
			>
				<router-link
					v-if="item.url"
					:to="item.url"
					:class="[$style.breadcrumbLink]"
				>
					<fa-icon
						v-if="item.icon"
						class="mr-2"
						:icon="item.icon"
					/> {{ item.name }}
				</router-link>
				<span
					v-else
					:class="[$style.breadcrumb]"
				>
					<fa-icon
						v-if="item.icon"
						class="mr-2"
						:icon="item.icon"
					/> {{ item.name }}
				</span>
			</li>
			<!-- <li v-for="(item, i) in breads" :key="i" :class="$style.breadcrumb">
				<router-link :to="{name: '_users'}" :class="[$style.breadcrumbLink,
				$style.breadcrumbLink__current]">
					<fa-icon v-if="item.icon" class="mr-2" :icon="item.icon" /> {{ item.name }}
				</router-link>
			</li> -->
			<li :class="[$style.breadcrumb, $style.breadcrumbLink__current]">
				<fa-icon
					v-if="$route.meta.icon"
					class="mr-2"
					:icon="$route.meta.icon"
				/>
				<a :class="[$style.breadcrumbLink , $style.breadcrumbLink__truncate]">{{ $title }}</a>
			</li>
		</ul>

		<div
			:class="$style.divider"
			class="mr-4 d-none d-xl-block"
		/>

		<!-- <p class="color-gray-4 text-uppercase font-size-18 mb-0 mr-4 d-none d-xl-block">
			INV-00125
		</p> -->

		<template v-if="$route.meta.topbar">
			<div class="ml-3 ml-sm-0 mr-sm-auto">
				<div
					v-for="(b,i) in buttons"
					:key="i"
					class="d-inline-block"
				>
					<a-button
						v-if="b.url"
						:type="b.variant"
						class="mr-2"
						:class="b.class"
						@click="$router.push(b.url);"
					>
						<span
							v-if="b.icon"
							class="mr-2"
						>
							<fa-icon :icon="b.icon" />
						</span>
						{{ b.text }}
					</a-button>
					<a-button
						v-else-if="b.event"
						:type="b.variant"
						class="mr-2"
						:class="b.class"
						@click="$hub.$emit(b.event);"
					>
						<span
							v-if="b.icon"
							class="mr-2"
						>
							<fa-icon :icon="b.icon" />
						</span>
						{{ b.text }}
					</a-button>
				</div>
			</div>
		</template>
		<!-- <div :class="$style.amount" class="mr-3 ml-auto d-none d-sm-flex">
			<p :class="$style.amountText">
				This month
				<span :class="$style.amountValue">$251.12</span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '80%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '70%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
			</div>
		</div>

		<div :class="$style.amount" class="d-none d-sm-flex">
			<p :class="$style.amountText">
				Last month
				<span :class="$style.amountValue">$12,256.12</span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '75%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '55%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '100%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '85%' }" />
			</div>
		</div> -->
	</div>
</template>

<script>

export default {
	data() {
		return {
			breads: null
		};
	},
	computed: {
		buttons() {
			const { buttons } = this.$route.meta.topbar;

			const result = [];
			if (buttons) {
				buttons.forEach((b) => {
					let pass = true;

					if (b.auth) {
						pass = this.$gestios.auth.check({ scopes: b.auth.roles, strict: b.auth.strict });
					}

					if (pass) {
						result.push({
							text: b.text,
							icon: b.icon,
							event: b.event || null,
							url: b.url || null,
							variant: b.variant,
							class: b.class
						});
					}
				});
			}

			return result;
		}
	},
	watch: {
		$route(to) {
			this.breads = to.meta.breads;
		}
	},
	created() {
		this.breads = this.$route.meta.breads;
	}
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
